import { render, staticRenderFns } from "./HelloClass.vue?vue&type=template&id=3f3dbbdc&scoped=true&"
import script from "./HelloClass.vue?vue&type=script&lang=ts&"
export * from "./HelloClass.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3dbbdc",
  null
  
)

export default component.exports